import { createSlice } from "@reduxjs/toolkit";

const inventorySlice = (name, defaultSortField = "createdAt", defaultSortOrder = "desc") => {
  const initialState = {
    pagination: { page: 0, pageSize: 15 },
    sortModel: [{ field: defaultSortField, sort: defaultSortOrder }],
    searchText: "",
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      setPagination: (state, action) => {
        state.pagination = action.payload;
      },
      setSortModel: (state, action) => {
        state.sortModel = action.payload;
      },
      setSearchText: (state, action) => {
        state.searchText = action.payload;
      },
      resetPage: state => {
      state.pagination.page = 0;
    },
      resetState: state => Object.assign(state, initialState),
    },
  });

  return slice;
};

export const monitorSlice = inventorySlice("monitor", "package_Name", "desc");
export const cpuSlice = inventorySlice("cpu", "package_Name", "desc"); 
export const keyboardSlice = inventorySlice("keyboard", "package_Name", "desc");
export const mouseSlice = inventorySlice("mouse", "package_Name", "desc");
export const headphoneSlice = inventorySlice("headphone", "package_Name", "desc");
export const dongleSlice = inventorySlice("dongle", "package_Name", "desc");
export const laptopSlice = inventorySlice("laptop", "package_Name", "desc");
export const miscellaneousSlice = inventorySlice("miscellaneous", "package_Name", "desc");

export const inventoryReducers = {
  monitor: monitorSlice.reducer,
  cpu: cpuSlice.reducer,
  keyboard: keyboardSlice.reducer,
  mouse: mouseSlice.reducer,
  headphone: headphoneSlice.reducer,
  dongle: dongleSlice.reducer,
  laptop: laptopSlice.reducer,
  miscellaneous: miscellaneousSlice.reducer,
};
